module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+R3JvdXAgMTA8L3RpdGxlPjxnIGZpbGw9IiM0RjNENzEiPjxwYXRoIGQ9Ik0xNCAuMkwxNS42IDIgMiAxNS44IDAgMTR6Ii8+PHBhdGggZD0iTTE1LjggMTRMMTQgMTUuOC40IDIgMiAuMnoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/menu_close.svg
// module id = 198
// module chunks = 1